import { type EnumType } from '@ncoderz/superenum';

const propertyKeys = {
  property_action: '@action',
  property_activityType: '@activityType',
  property_additionalSolutions: '@additionalSolutions',
  property_advertisingClickUrl: '@advertisingClickUrl',
  property_ageRange: '@ageRange',
  property_aiGenerated: '@aiGenerated',
  property_allowedBit: '@allowedBit',
  property_allowPrint: '@allowPrint',
  property_allowSubtitles: '@allowSubtitles',
  property_alt: '@alt',
  property_altLangTag: '@altLangTag',
  property_analyticsTag: '@analyticsTag',
  property_author: '@author',
  property_authorFullName: '@authorFullName',
  property_authorJobTitle: '@authorJobTitle',
  property_authorPseudonym: '@authorPseudonym',
  property_authorTitle: '@authorTitle',
  property_autoplay: '@autoplay',
  property_availableClassifications: '@availableClassifications',
  property_brandColor: '@brandColor',
  property_brandColorName: '@brandColorName',
  property_backgroundImage: '@backgroundImage',
  property_blockId: '@blockId',
  property_book: '@book',
  property_bookAlias: '@bookAlias',
  property_bookDiff: '@bookDiff',
  property_bot: '@bot',
  property_bubbleTag: '@bubbleTag',
  property_extractorTag: '@extractorTag',
  property_extractorInternal: '@extractorInternal',
  property_bitFingerprint: '@bitFingerprint',
  property_buttonCaption: '@buttonCaption',
  property_callToActionUrl: '@callToActionUrl',
  property_caption: '@caption',
  property_categoryTag: '@categoryTag',
  property_chatWithBook: '@chatWithBook',
  property_chatWithBookBrainKey: '@chatWithBookBrainKey',
  property_currency: '@currency',
  property_bookIsbn: '@bookIsbn',
  property_bookAuthor: '@bookAuthor',
  property_bookType: '@bookType',
  property_bookBindingType: '@bookBindingType',
  property_bookNumberOfPages: '@bookNumberOfPages',
  property_bookRating: '@bookRating',
  property_bookSeriesTitle: '@bookSeriesTitle',
  property_bookSeriesId: '@bookSeriesId',
  property_bookSeriesNumber: '@bookSeriesNumber',
  property_bookLanguage: '@bookLanguage',
  property_bookPublishingDate: '@bookPublishingDate',
  property_bookPublisher: '@bookPublisher',
  property_bookTranslator: '@bookTranslator',
  property_bookOriginalTitle: '@bookOriginalTitle',
  property_gmbExternalShop: '@gmbExternalShop',
  property_gmbExternalShopItems: '@gmbExternalShopItems',
  property_citationStyle: '@citationStyle',
  property_classification: '@classification',
  property_codeLineNumbers: '@codeLineNumbers',
  property_codeMinimap: '@codeMinimap',
  property_color: '@color',
  property_colorTag: '@colorTag',
  property_computerLanguage: '@computerLanguage',
  property_content2Buy: '@content2Buy',
  property_listPrice: '@listPrice',
  property_customerProductId: '@customerProductId',
  property_customerProductShopLink: '@customerProductShopLink',
  property_copyright: '@copyright',
  property_coverColor: '@coverColor',
  property_coverImage: '@coverImage',
  property_customerExternalId: '@customerExternalId',
  property_customerId: '@customerId',
  property_date: '@date',
  property_dateEnd: '@dateEnd',
  property_decimalPlaces: '@decimalPlaces',
  property_deeplink: '@deeplink',
  property_displayName: '@displayName',
  property_diffContext: '@diffContext',
  property_diffOp: '@diffOp',
  property_diffRef: '@diffRef',
  property_diffTime: '@diffTime',
  property_diffTo: '@diffTo',
  property_disableCalculation: '@disableCalculation',
  property_disableFeedback: '@disableFeedback',
  property_duration: '@duration',
  property_isEditable: '@isEditable',
  property_needsValidation: '@needsValidation',
  property_validationDate: '@validationDate',
  property_emphasis: '@emphasis',
  property_example: '@example',
  property_externalId: '@externalId',
  property_externalLink: '@externalLink',
  property_externalLinkText: '@externalLinkText',
  property_feedbackEngine: '@feedbackEngine',
  property_feedbackType: '@feedbackType',
  property_userFeedbackTranslationUrl: '@userFeedbackTranslationUrl',
  property_userFeedbackContentUrl: '@userFeedbackContentUrl',
  property_flashcardSet: '@flashcardSet',
  property_focusX: '@focusX',
  property_focusY: '@focusY',
  property_format: '@format',
  property_formula: '@formula',
  property_fullName: '@fullName',
  property_groupTag: '@groupTag',
  property_gUri: '@gUri',
  property_handInAcceptFileType: '@handInAcceptFileType',
  property_handInInstruction: '@handInInstruction',
  property_handInRequirement: '@handInRequirement',
  property_hasBookNavigation: '@hasBookNavigation',
  property_hasMarkAsDone: '@hasMarkAsDone',
  property_height: '@height',
  property_icon: '@icon',
  property_iconTag: '@iconTag',
  property_id: '@id',
  property_iframeSrc: '@iframeSrc',
  property_iframeName: '@iframeName',
  property_imageFirst: '@imageFirst',
  property_imageSource: '@imageSource',
  property_index: '@index',
  property_internalComment: '@internalComment',
  property_internalPrintPdf: '@internalPrintPdf',
  property_hasPrintRestriction: '@hasPrintRestriction',
  property_enforceUpdateOverUserInput: '@enforceUpdateOverUserInput',
  property_extractorExtractionTimestamp: '@extractorExtractionTimestamp',
  property_isCaseSensitive: '@isCaseSensitive',
  property_isCollapsible: '@isCollapsible',
  property_isInfoOnly: '@isInfoOnly',
  property_isPublic: '@isPublic',
  property_isTemplate: '@isTemplate',
  property_isTemplateStripTheme: '@isTemplateStripTheme',
  property_isTracked: '@isTracked',
  property_jobTitle: '@jobTitle',
  property_jupyterExecutionCount: '@jupyterExecutionCount',
  property_jupyterId: '@jupyterId',
  property_kind: '@kind',
  property_label: '@label',
  property_labelFalse: '@labelFalse',
  property_labelTrue: '@labelTrue',
  property_lang: '@lang',
  property_language: '@language',
  property_layer: '@layer',
  property_layerRole: '@layerRole',
  property_levelACTFL: '@levelACTFL',
  property_levelCEFR: '@levelCEFR',
  property_levelCEFRp: '@levelCEFRp',
  property_levelILR: '@levelILR',
  property_license: '@license',
  property_list: '@list',
  property_listItemIndent: '@listItemIndent',
  property_location: '@location',
  property_machineTranslated: '@machineTranslated',
  property_translationOf: '@translationOf',
  property_translationOfBook: '@translationOfBook',
  property_spansPageBreak: '@spansPageBreak',
  property_mailingList: '@mailingList',
  property_mark: '@mark',
  property_maxCreatedBits: '@maxCreatedBits',
  property_maxDisplayLevel: '@maxDisplayLevel',
  property_maxTocChapterLevel: '@maxTocChapterLevel',
  property_mockupId: '@mockupId',
  property_mute: '@mute',
  property_padletId: '@padletId',
  property_page: '@page',
  property_printParentChapterLevel: '@printParentChapterLevel',
  property_printOnRequestCustomerId: '@printOnRequestCustomerId',
  property_printOnRequestProductId: '@printOnRequestProductId',
  property_pageNo: '@pageNo',
  property_partialAnswer: '@partialAnswer',
  property_partner: '@partner', // Deprecated, replaced by person
  property_path: '@path',
  property_platformBackgroundColor: '@platformBackgroundColor',
  property_platformBorderColor: '@platformBorderColor',
  property_platformBrandTarget: '@platformBrandTarget',
  property_platformButtonBackgroundColor: '@platformButtonBackgroundColor',
  property_platformButtonPrimaryColor: '@platformButtonPrimaryColor',
  property_platformMessageBackgroundColor: '@platformMessageBackgroundColor',
  property_platformName: '@platformName',
  property_platformPlaceholderColor: '@platformPlaceholderColor',
  property_platformPrimaryColor: '@platformPrimaryColor',
  property_platformScrollbarColor: '@platformScrollbarColor',
  property_platformSecondaryColor: '@platformSecondaryColor',
  property_platformSelectionColor: '@platformSelectionColor',
  property_platformSelectionTextColor: '@platformSelectionTextColor',
  property_platformBaseLayerColor: '@platformBaseLayerColor',
  property_platformMargin: '@platformMargin',
  property_platformBorderRadius: '@platformBorderRadius',
  property_platformSelectionBorderRadius: '@platformSelectionBorderRadius',
  property_platformLogoMaxHeight: '@platformLogoMaxHeight',
  property_platformNeedsShadow: '@platformNeedsShadow',
  property_platformSeparatorColor: '@platformSeparatorColor',
  property_platformTextSelectionColor: '@platformTextSelectionColor',
  property_person: '@person',
  property_pointerLeft: '@pointerLeft',
  property_pointerTop: '@pointerTop',
  property_posterImage: '@posterImage',
  property_processHandIn: '@processHandIn',
  property_processHandInLocation: '@processHandInLocation',
  property_product: '@product',
  property_productFolder: '@productFolder',
  property_productId: '@productId',
  property_productVideo: '@productVideo',
  property_progress: '@progress',
  property_pseudonym: '@pseudonym',
  property_publications: '@publications',
  property_publisher: '@publisher',
  property_publisherName: '@publisherName',
  property_quizCountItems: '@quizCountItems',
  property_quizStrikethroughSolutions: '@quizStrikethroughSolutions',
  property_quotedPerson: '@quotedPerson',
  property_ratingLevelEnd: '@ratingLevelEnd',
  property_ratingLevelSelected: '@ratingLevelSelected',
  property_ratingLevelStart: '@ratingLevelStart',
  property_reaction: '@reaction',
  property_reasonableNumOfChars: '@reasonableNumOfChars',
  property_reductionTag: '@reductionTag',
  property_refAuthor: '@refAuthor',
  property_refBookTitle: '@refBookTitle',
  property_reference: '@reference',
  property_refPublicationYear: '@refPublicationYear',
  property_refPublisher: '@refPublisher',
  property_relatedBook: '@relatedBook',
  property_releaseDate: '@releaseDate',
  property_releaseKind: '@releaseKind',
  property_releaseVersion: '@releaseVersion',
  property_reportTag: '@reportTag',
  property_resolved: '@resolved',
  property_resolvedBy: '@resolvedBy',
  property_resolvedDate: '@resolvedDate',
  property_revealSolutions: '@revealSolutions',
  property_reviewTag: '@reviewTag',
  property_reviewerTag: '@reviewerTag',
  property_rightsPolicy: '@rightsPolicy',
  property_sampleSolution: '@sampleSolution',
  property_scormSource: '@scormSource',
  property_search: '@search',
  property_searchIndex: '@searchIndex',
  property_selected: '@selected',
  property_servings: '@servings',
  property_showInIndex: '@showInIndex',
  property_showSubtitles: '@showSubtitles',
  property_siteName: '@siteName',
  property_size: '@size',
  property_slug: '@slug',
  property_sourceBB: '@sourceBB',
  property_sourceDocument: '@sourceDocument',
  property_sourceRL: '@sourceRL',
  property_spaceId: '@spaceId',
  property_src1x: '@src1x',
  property_src2x: '@src2x',
  property_src3x: '@src3x',
  property_src4x: '@src4x',
  property_srcAlt: '@srcAlt',
  property_stripePricingTableId: '@stripePricingTableId',
  property_stripePricingTableDescriptiveName: '@stripePricingTableDescriptiveName',
  property_stripePublishableKey: '@stripePublishableKey',
  property_subject: '@subject',
  property_subtype: '@subtype',
  property_tableAutoWidth: '@tableAutoWidth',
  property_tableColWidth: '@tableColWidth',
  property_tableColumnMinWidth: '@tableColumnMinWidth',
  property_tableFixedHeader: '@tableFixedHeader',
  property_tableHeaderWhitespaceNoWrap: '@tableHeaderWhitespaceNoWrap',
  property_tableHeight: '@tableHeight',
  property_tablePagination: '@tablePagination',
  property_tablePaginationLimit: '@tablePaginationLimit',
  property_tableResizableColumns: '@tableResizableColumns',
  property_tableSearch: '@tableSearch',
  property_tableSort: '@tableSort',
  property_tableWhitespaceNoWrap: '@tableWhitespaceNoWrap',
  property_tableCellType: '@tableCellType',
  property_tableRowSpan: '@tableRowSpan',
  property_tableColSpan: '@tableColSpan',
  property_tableScope: '@tableScope',
  property_tag: '@tag',
  property_target: '@target',
  property_technicalTerm: '@technicalTerm',
  property_textReference: '@textReference',
  property_theme: '@theme',
  property_rtl: '@rtl',
  property_thumbImage: '@thumbImage',
  property_title: '@title',
  property_toc: '@toc',
  property_tocContent: '@tocContent',
  property_tocResource: '@tocResource',
  property_topicTag: '@topicTag',
  property_trim: '@trim',
  property_unit: '@unit',
  property_unitAbbr: '@unitAbbr',
  property_unitAbbrPlural: '@unitAbbrPlural',
  property_unitPlural: '@unitPlural',
  property_vendorDashboardId: '@vendorDashboardId',
  property_vendorSurveyId: '@vendorSurveyId',
  property_vendorUrl: '@vendorUrl',
  property_videoCallLink: '@videoCallLink',
  property_width: '@width',
  property_x: '@x',
  property_y: '@y',
  property_zoomDisabled: '@zoomDisabled',
} as const;

const PropertyKey = propertyKeys;

export type PropertyKeyType = EnumType<typeof PropertyKey>;

export { PropertyKey, propertyKeys };
